import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { typeLabels } from "@/mocks/filters";
import { mediaList, type ContentType } from "@/mocks/media";

const tabs: { key: ContentType; label: string }[] = [
  { key: "movie", label: "热门电影" },
  { key: "tv", label: "热门剧集" },
  { key: "variety", label: "热门综艺" },
];

export default function HotRecommend() {
  const [active, setActive] = useState<ContentType>("movie");

  const items = useMemo(
    () =>
      mediaList
        .filter((item) => item.type === active)
        .sort((a, b) => b.heat - a.heat)
        .slice(0, 4),
    [active],
  );

  return (
    <section className="w-full bg-background-100/60 px-4 py-12 md:px-6 md:py-14">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.22em] text-accent-600">
            <span className="h-px w-6 bg-accent-500" />
            Trending Now
          </p>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            热门推荐
          </h2>
          <p className="mt-2 text-[13px] text-foreground-600">按本周播放热度排序，切换标签查看不同类别的热门作品</p>
        </div>
        <div className="flex w-fit items-center gap-1 rounded-full border border-background-300/70 bg-background-50 p-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-[12px] transition-colors ${
                active === tab.key
                  ? "bg-primary-500 font-medium text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {items.map((item, index) => (
          <div key={item.id} className="relative animate-fade-up" style={{ animationDelay: `${index * 60}ms` }}>
            <span className="absolute -left-0.5 -top-0.5 z-10 flex h-6 w-6 items-center justify-center rounded-sm bg-accent-500 font-label text-[11px] font-bold text-background-50">
              {index + 1}
            </span>
            <MediaCard item={item} />
          </div>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <Link
          to={`/category/${active}`}
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-[13px] font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:text-accent-600"
        >
          查看全部{typeLabels[active]}
          <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
        </Link>
      </div>
    </section>
  );
}